import React, { FC, useCallback } from 'react'
import classnames from 'classnames'
import { useTranslations } from 'next-intl'
import { OUTDATED_LINK } from './constants'
import { BackArrow } from './components/BackArrow'
import style from './BackArrowButton.module.css'

type BackArrowButtonProps = {
  className?: string
}

export const BackArrowButton: FC<BackArrowButtonProps> = ({ className }) => {
  const t = useTranslations()
  const classNames = classnames(style.backArrowButton, className)

  const onClickHandler = useCallback(() => {
    window.location.href = t(OUTDATED_LINK)
  }, [t])

  return (
    <button type="button" className={classNames} onClick={onClickHandler}>
      <BackArrow />
    </button>
  )
}
